var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IconSide08"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L18 0L18 18L0 18L0 0Z",
    id: "IconSide08",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L18 0L18 18L0 18L0 0Z",
    id: "Path",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15L17.25 15L17.25 16.5L0.75 16.5L0.75 15L2.25 15L2.25 2.25C2.25 1.83579 2.58579 1.5 3 1.5L15 1.5C15.4142 1.5 15.75 1.83579 15.75 2.25L15.75 15ZM6 8.25L6 9.75L8.25 9.75L8.25 8.25L6 8.25ZM6 5.25L6 6.75L8.25 6.75L8.25 5.25L6 5.25ZM6 11.25L6 12.75L8.25 12.75L8.25 11.25L6 11.25ZM9.75 11.25L9.75 12.75L12 12.75L12 11.25L9.75 11.25ZM9.75 8.25L9.75 9.75L12 9.75L12 8.25L9.75 8.25ZM9.75 5.25L9.75 6.75L12 6.75L12 5.25L9.75 5.25Z",
    id: "Shape",
    fill: "#7E6DD6",
    stroke: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.a497dd3be6a4dcdeb070297e98495128.svg";
export { ForwardRef as ReactComponent };